import type { Icon } from '$lib/types/icons';
import { DateTime } from 'luxon';
import { derived, writable } from 'svelte/store';

export const toastStore = writable<Toast[]>([]);

// define Toast interface
export interface Toast {
	text: string;
	icon?: Icon;
	bgColor?: string;
	goto?: string | (() => void);
	fixed?: boolean;
	date?: number;
	timeout?: NodeJS.Timeout;
}

function addToast(toast: Toast) {
	toast.date = DateTime.now().toMillis() + Math.random();
	toastStore.update((value) => {
		return [...value, toast];
	});
}

export const toast = derived(toastStore, () => (toast: Toast) => {
	addToast(toast);
});

export function toastError(text: string) {
	addToast({ text, icon: 'bang', bgColor: 'error' });
}
